// In src/components/ApprovedUserRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ApprovedUserRoute = ({ children }) => {
  const { userProfile, isInitialized } = useAuth();

  // Show a loading spinner while the user's profile is being fetched
  if (!isInitialized) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If the profile is loaded and the status is 'active', show the requested page
  if (userProfile && userProfile.status === 'active') {
    return children;
  }

  // If the user is not approved, redirect them to the home page
  // where they will see the pending approval notice from the Layout component.
  return <Navigate to="/" />;
};

export default ApprovedUserRoute;